<script>
export default {
  name: "ReportsIndex",
};
</script>

<template>
  <div class="h-full w-full">
    <router-view></router-view>
  </div>
</template>

<style scoped lang="scss"></style>
